import { resolveDeployment } from './deploymentConfig';

const config = resolveDeployment({
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    REACT_APP_PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
    REACT_APP_TEMP_SERVER: process.env.REACT_APP_TEMP_SERVER,
    REACT_APP_SERVER_BASE: process.env.REACT_APP_SERVER_BASE,
});
if (process.env.NODE_ENV === 'production' && window.location.origin !== config.publicUrl) {
    throw new Error('This build belongs to a different customer website. Check the deployment configuration.');
}
export default config.apiUrl;
